import { render, staticRenderFns } from "./CreateDlg.vue?vue&type=template&id=246950ac"
import script from "./CreateDlg.vue?vue&type=script&lang=js"
export * from "./CreateDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports